<template>
	<div class="content">
		<div class="header">
			<nav class="navbar navbar-expand-lg navbar-light">
				<a href="/" class="navbar-brand">
					<img class="logo_a" src="/images/icon-76x76.png" alt="BienParaBien.com" title="BienParaBien.com">
					<img class="logo_b" src="/images/distritopyme_logo.png" alt="Distrito Pyme" title="Distrito Pyme">
				</a>

				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navMain" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
				</button>

				<div id="navMain" class="collapse navbar-collapse">
					<ul class="navbar-nav">
						<li class="nav-item">
							<a href="" class="nav-link nav-active" v-scroll-to="'#credito'">QUIERO MI CRÉDITO</a>
						</li>
						<li class="nav-item">
							<a href="" class="nav-link" v-scroll-to="'#ventajas'">VENTAJAS</a>
						</li>
						<li class="nav-item">
							<a href="" class="nav-link" v-scroll-to="'#requisitos'">REQUISITOS</a>
						</li> 
						<li class="nav-item">
							<a href="" class="nav-link" v-scroll-to="'#plazas'">PLAZAS</a>
						</li>
						<li class="nav-item">
							<a href="#" class="nav-link" @click="cerrarSesion">CERRAR SESIÓN</a>
						</li>
					</ul>
				</div>
			</nav>
		</div>
		<div class="main">
			<div class="component">
				<Hooper 
					:autoPlay="true" 
					:playSpeed="5000" 
					:wheelControl="false" 
					:mouseDrag="false" 
					:touchDrag="false" 
					:keysControl="false" 
					:hoverPause="false">
					<slide><img src="/images/thumb1.jpg" alt="x"></slide>
					<slide><img src="/images/thumb2.jpg" alt="xx"></slide>
					<slide><img src="/images/thumb3.jpg" alt="xxx"></slide>
				</Hooper>
				<div id="credito" class="credito-info">
					<div class="row">
						<div class="col-md-12 subtitle">
							El crédito más flexible que se adapta a tu necesidad.
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<ul>
								<li>Préstamo Personal y Pago de pasivos.</li>
								<li>Créditos para tu PyME.</li>
								<li>Créditos para tu negocio.</li>
								<li>Créditos para capital de trabajo.</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="credito">
					<div class="row">
						<div class="title col-sm-12">Solicita tu <span>Crédito</span></div>
					</div>
					<div class="row">
						<div class="subtitle col-sm-12">
							Préstamo
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<input v-model="form.montoPrestamo" type="text" name="montoPrestamo" id="montoPrestamo" class="form-control" v-money="form.montoPrestamo !== null ? money : null" placeholder="Monto del préstamo">
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<select v-model="form.plazos" name="plazos" id="plazos" class="form-control">
								<option value="0">Plazos</option>
								<option value="1">1 años</option>
								<option value="2">2 años</option>
								<option value="3">3 años</option>
								<option value="4">4 años</option>
								<option value="5">5 años</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="subtitle col-sm-12">
							Datos del solicitante
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<input v-model="form.nombre" type="text" name="nombre" id="nombre" class="form-control" placeholder="Nombres">
						</div>
						<div class="col-sm-6">
							<input v-model="form.apellido_paterno" type="text" name="nombre" id="nombre" class="form-control" placeholder="Apellido paterno">
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<input v-model="form.apellido_materno" type="text" name="nombre" id="nombre" class="form-control" placeholder="Apellido materno">
						</div>
						<div class="col-sm-6">
							<input v-model="form.ingreso" type="text" name="ingresoMensual" id="ingresoMensual" class="form-control" placeholder="Ingreso mensual" v-money="form.ingreso !== null ? money : null">
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<input v-model="form.email" type="email" name="email" id="email" class="form-control" placeholder="Mail" @change="validarEmail">
						</div>
						<div class="col-sm-6">
							<input v-model="form.telefono" type="number" name="telefono" id="telefono" class="form-control" placeholder="Teléfono">
						</div>
					</div>
					<div class="row">
						<div class="subtitle col-sm-12">
							Datos de la garantía
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<select v-model="form.tipoPropiedad" name="tipoPropiedad" id="tipoPropiedad" class="form-control">
								<option value="0">Tipo de propiedad</option>
								<option value="1">Casa Sola</option>
								<option value="2">Casa Condominio</option>
								<option value="3">Departamento</option>
								<option value="4">Local Comercial</option>
								<option value="7">Oficina</option>
							</select>
						</div>
						<div class="col-sm-6">
							<input v-model="form.valorPropiedad" type="text" name="valorPropiedad" id="valorPropiedad" class="form-control" v-money="form.valorPropiedad !== null ? money : null" placeholder="Valor de propiedad">
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<input v-model="form.cp" type="number" name="cp" id="cp" class="form-control" placeholder="Código postal" @keyup="searchCP" autocomplete="off">
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<input v-model="form.estado" type="text" name="estado" id="estado" class="form-control" placeholder="Estado">
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<input v-model="form.municipio" type="text" name="municipio" id="municipio" class="form-control" placeholder="Municipio / Alcaldía">
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<select v-model="form.colonia" name="colonia" id="colonia" class="form-control">
								<option value="0">Colonia</option>
								<option v-for="colonia in colonias" :value="colonia">{{ colonia }}</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<input v-model="form.calle" type="text" name="calle" id="calle" class="form-control" placeholder="Calle y número">
						</div>
					</div>
					<div class="row">
						<div class="subtitle col-sm-12">
							Como prefieres que te contactemos
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<select v-model="form.contacto_preferido" name="contacto_preferido" id="contacto_preferido" class="form-control">
								<option value="telefono">Teléfono</option>
								<option value="whatsapp">WhatsApp</option>
								<option value="email">Correo electrónico</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<input v-model="form.politicas" type="checkbox" name="politicas" id="politicas"> Acepto las <a href="" title="">políticas de privacidad</a>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12 text-center">
							<button id="obtenerCredito" @click="obtenerCredito">Obtener mi crédito</button>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12 info">
							Para un crédito $2,000,000, tasa de interés del 24%, con gastos notariales estimados $50,000 y plazo a 5 año el CAT 32.41% sin IVA sólo para fines informativos y de comparación exclusivamente, calculado el 20 de septiembre de 2018.
						</div>
					</div>
				</div>
				<div class="info-general container">
					<div class="row">
						<div class="col-sm-6">
							<p class="subtitle">Tu crédito desde <span>$200,000</span> y hasta <span>$5,000,000</span></p>

							<ul>
								<li>Tasa FIJA competitiva desde el 20% hasta el 28%</li>
								<li>Plazo desde 1 año hasta 5 años</li>
								<li>Te precalificamos de inmediato</li>
								<li>Línea adicional de $50,000 hasta $200,000 para desarrollo empresarial</li>
								<li>Requerimientos y documentos mínimos</li>
								<li>Sin coomisión por apertura</li>
							</ul>
						</div>
					</div>
				</div>
				<div id="requisitos" class="requisitos container">
					<div class="row">
						<div class="col-sm-12 col-md-5 video">
							<p>Sólo necesitas tener: <br/><span>Un inmueble sin gravamen</span></p>
							<p><button @click="showVideo=true">Ver Video</button></p>
						</div>
						<div class="col-sm-12 col-md-7 pasos">
							<ol>
								<li><img src="/images/paso-1.png" alt="">Llenar el formulario de precalificación en línea</li>
								<li><img src="/images/paso-2.png" alt="">De inmediato te informamos si tu solicitud fue aceptada.</li>
								<li><img src="/images/paso-3.png" alt="">Un asesor te llama por teléfono y programamos una entrevista con Bien para Bien.</li>
								<li><img src="/images/paso-4.png" alt="">En un máximo de 48 horas te informamos si el crédito fue autorizado.</li>
							</ol>
						</div>
					</div>
				</div>
				<div id="ventajas" class="descript container">
					<div class="row">
						<div class="col-sm-12 col-md-2 offset-md-1">
							<img src="/images/icon-76x76.png" alt="BienParaBien.com" title="BienParaBien.com"> <span>es:</span>
						</div>
						<div class="col-sm-12 col-md-2">
							<span>Transparente</span><br/> Sin letras chiquitas ni trámites burocráticos
						</div>
						<div class="col-sm-12 col-md-2">
							<span>Honesto</span><br/> Entendemos tus necesidades y te ayudamos a través de una red de alianzas para asesorar tu plan de negocios
						</div>
						<div class="col-sm-12 col-md-2">
							<span>Rápido</span><br/> Preaprobamos tu crédito de inmediato
						</div>
						<div class="col-sm-12 col-md-2">
							<span>Justo</span><br/> Un crédito que cubre tus necesidades sin rebasar tus posibilidades
						</div>
					</div>
				</div>
				<div id="plazas" class="plazas">
					<div class="bg">
						<div class="container">
							<div class="row">
								<div class="col-sm-12 subtitle">
									Las plazas donde estamos otorgando crédito son:
								</div>
							</div>
							<div class="row">
								<div class="col-md-3">
									<ul>
										<li>Ciudad de México</li>
										<li>Estado de México</li>
										<li>Morelos</li>
										<li>Tlaxcala</li>
										<li>Puebla</li>
										<li>Veracruz</li>
										<li>Nueva León</li>
									</ul>
								</div>
								<div class="col-md-3">
									<ul>
										<li>Guanajuato</li>
										<li>San Luis Potosí</li>
										<li>Zacatecas</li>
										<li>Jalisco</li>
										<li>Baja California</li>
										<li>Colima</li>
										<li>Yucatán</li>
									</ul>
								</div>
								<div class="col-md-3">
									<ul>
										<li>Tabasco</li>
										<li>Hidalgo</li>
										<li>Aguascalientes</li>
										<li>Querétaro</li>
										<li>Quintana Roo</li>
										<li>Chihuahua</li>
										<li>Chiapas</li>
									</ul>
								</div>
								<div class="col-md-3">
									<ul>
										<li>Baja California Sur</li>
										<li>Sinaloa</li>
										<li>Coahuila</li>
										<li>Nayarit</li>
										<li>Durango</li>
										<li>Sonora</li>
										<li>Campeche</li>
									</ul>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 button">
									<button v-scroll-to="'#credito'">QUIERO MI CRÉDITO</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="logos container">
					<div class="row">
						<div class="col-sm-12 col-md-2 offset-md-1">
							<a href="https://www.buro.gob.mx/" target="_blank" rel="noopener noreferrer">
								<img src="/images/logo_buro.png" alt="Ir al sitio de Buró de Crédito">
							</a>
						</div>
						<div class="col-sm-12 col-md-2">
							<a href="http://www.condusef.gob.mx/" target="_blank" rel="noopener noreferrer">
								<img src="/images/condusef.png" alt="Ir al sitio de CONDUSEF">
							</a>
						</div>
						<div class="col-sm-12 col-md-2">
							<a href="https://www.fintechmexico.org/" target="_blank" rel="noopener noreferrer">
								<img src="/images/Logo_fintech_mx.png" alt="Ir al sitio de Fintech Mexico">
							</a>
						</div>
						<div class="col-sm-12 col-md-2">
							<a href="http://asofom.mx/asociados/" target="_blank" rel="noopener noreferrer">
								<img src="/images/asofom.png" alt="Ir al sitio de ASOFOM">
							</a>
						</div>
						<div class="col-sm-12 col-md-2">
							<img src="/images/GCP.png" alt="Powered by Google Cloud Platform">
						</div>
					</div>
				</div>
			</div>
			<div v-if="showVideo" class="player_bg" @click="showVideo=false"></div>
			<div v-if="showVideo" class="player_iframe">
				<iframe src="https://www.youtube.com/embed/62aXHIuGmSY?controls=0?autoplay=1&hd=1&rel=0?modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
			</div>
			<div v-if="showVideo" class="player_close" @click="showVideo=false">
				<img src="/images/close.png" alt="Cerrar" title="Cerrar">
			</div>
			<div class="player_bg" v-if="form.montoPreAprobado !== null && form.montoPreAprobado != ''"></div>
			<div class="confirm-dialog container" v-if="form.montoPreAprobado !== null && form.montoPreAprobado != ''">
				<div class="row">
					<div class="col-sm-12 text-center">
						<img class="title" :src="mssg.img" alt="Success">
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<div class="row">
							<div class="col-sm-12 subtitle">{{ mssg.subtitle }}</div>
						</div>
						<div class="row">
							<div class="col-sm-12 info"> {{ mssg.mssg }}</div>
						</div>
						<div class="row">
							<div class="col-sm-12 text-center buttons">
								<button v-for="btn in mssg.buttons" :id="btn.id" :class="btn.class" @click="dynamicAction($event, btn.action)">{{ btn.text }}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<UploadFile :show.sync="uploadFiles" :solicitud="infoSolicitud"></UploadFile>
		</div>
		<div class="footer">
			Todos los derechos reservados. &copy; Bien para Bien SAPI de C.V, SOFOM ENR. {{ (new Date()).getFullYear() }}
		</div>
	</div>
</template>

<script type="text/javascript">
	import { Hooper, Slide } from 'hooper'
	import 'hooper/dist/hooper.css'
	import {VMoney} from 'v-money'
	import axios from 'axios'
	import firebase from 'firebase/app'
	import 'firebase/firestore'
	import validate from '@/libraries/validacion'
	import Vue2Filters from 'vue2-filters'
	import UploadFile from '@/modules/others/UploadFile'

	export default {
		components: {
			Hooper
			,Slide
			,VMoney
			,UploadFile
		}
		,directives: {
			money: VMoney
		}
		,data: () => {
			return {
				showVideo: false
				,money: {
					decimal: '.'
					,thousands: ','
					,prefix: '$ '
					,precision: 0
					,masked: false
				}
				,colonias: []
				,form: {
					montoPrestamo: null
					,montoPreAprobado: null
					,aceptarPreAprobado: 0
					,plazos: 0
					,nombre: null
					,apellido_paterno: null
					,apellido_materno: null
					,ingreso: null
					,email: null
					,telefono: null
					,tipoPropiedad: 0
					,valorPropiedad: null
					,estado: null
					,municipio: null
					,colonia: 0
					,calle: null
					,cp: null
					,contacto_preferido: 'telefono'
					,politicas: false
					,createdAt: null
					,updatedAt: null
				}
				,mssg: {
					img: null
					,subtitle: null
					,mssg: null
					,buttons: []
				}
				,uploadFiles: false
				,infoSolicitud: null
			}
		}
		,computed: {
			plazosMeses: function() {
				return this.form.plazos * 12;
			}
			,montoPrestamoFloat: function() {
				let monto = this.form.montoPrestamo;
				if (monto !== null) {
					monto = monto.replace(/\$/g, '');
					monto = monto.replace(/\,/g, '');

					return parseFloat(monto);
				}else
					return this.form.montoPrestamo;
			}
		}
		,methods: {
			cerrarSesion: function(e) {
				sessionStorage.setItem('auth','');

				this.$router.push({name: 'login'});
				firebase.auth().signOut();

				e.preventDefault();
			}
			,validarEmail: function(e) {
				let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

				if (!reg.test(e.target.value)) {
					e.target.classList.add('is-invalid');
					this.$swal({
						type: 'error'
						,title: 'Oops...'
						,text: 'Debes especificar un email válido'
						,toast: true
				        ,position: 'top-end'
				        ,showConfirmButton: false
				        ,timer: 3500
					});
				}else {
					if (e.target.classList.contains('is-invalid'))
						e.target.classList.remove('is-invalid');
				}
			}
			,searchCP: function(e) {
				if (e.target.value.length >=  5) {
					let url = 'https://servicios.bienparabien.dev/api/ws/codigo_postal/'+e.target.value+'/G1qMRi3LgEzsLyQTxUxkaZzCs6qPumv21hLLHaai';
					axios.get(url)
					.then(res => {
						this.form.estado = res.data.resultado.estado;
						this.form.municipio = res.data.resultado.municipio;
						this.colonias = res.data.resultado.colonias;
					})
					.catch(err => {
						this.$swal({
							type: 'error'
							,title: 'Oops...'
							,text: err.message
							,toast: true
					        ,position: 'top-end'
					        ,showConfirmButton: false
					        ,timer: 3500
						});
					});
				}
			}
			,importeCalc (tasa, ingreso_mensual, plazo) {
				const C3 = tasa;
				const C8 = 1/(1+(C3/12));
				const E3 = plazo;

				const C9 = (1-(C8**E3))/(C3/12);
				const E24 = ingreso_mensual;

				const C31 = C9;
				const C32 = E24 * 0.35;

				return C31 * C32;
			}
			,obtenerCredito: function() {
				let time = 6000;

				if (validate.validate(this.form, this.$swal, 6000)) {
					this.form.montoPreAprobado = this.importeCalc(0.28, this.form.ingreso, parseInt(this.plazosMeses)).toFixed(2);
					this.showAlert();
				}
			}
			,aceptarPre: function(e) {
				this.form.aceptarPreAprobado = 1;

				this.guardarDatos(e);
			}
			,guardarDatos: function(e) {
				this.mssg.buttons.forEach(function(item) {
					document.getElementById(item.id).disabled = true;
				});

				let monto_pre_a = document.getElementById('monto_pre_a');
				if (monto_pre_a)
					monto_pre_a.disabled = true;

				let monto_org_a = document.getElementById('monto_org_a');
				if (monto_org_a)
					monto_org_a.disabled = true;

				let monto_org_b = document.getElementById('monto_org_b');
				if (monto_org_b)
					monto_org_b.disabled = true;

				let db = firebase.firestore();

				this.form.createdAt = new Date();
				this.form.updatedAt = new Date();

				this.$log.info('Colección: '+process.env.VUE_APP_SOLICITUDES_COLLECTION);
				db.collection(process.env.VUE_APP_SOLICITUDES_COLLECTION).add(this.form)
				.then(res => {
					//Se guarda correctamente los datos
					
					let importe_solicitado = this.form.montoPrestamo.replace(/\$/g, '');
					importe_solicitado = importe_solicitado.replace(/\,/g, '');

					let valorPropiedad = this.form.valorPropiedad.replace(/\$/g, '');
					valorPropiedad = valorPropiedad.replace(/\,/g, '');

					let ingreso_mensual = this.form.ingreso.replace(/\$/g, '');
					ingreso_mensual = ingreso_mensual.replace(/\,/g, '');

					// let data = {
					// 	email: this.form.email
					// 	,nombre: this.form.nombre
					// 	,ingreso_mensual: ingreso_mensual
					// 	,telefono: this.form.telefono
					// 	,importe_solicitado: importe_solicitado
					// 	,importe_pre_autorizado: this.form.montoPreAprobado
					// 	,acepta_pre_autorizado: this.form.aceptarPreAprobado
					// 	,plazo: this.form.plazos
					// 	,medioinformacion_id: 36
					// 	,promotor_id: 2
					// 	,descripcion_solicitud: 'Solicitud enviada vía micrositio Distrito PyME'
					// 	,acepta_politicas_privacidad: this.form.politicas
					// 	,tipogarantia_id: this.form.tipoPropiedad
					// 	,propia: 1
					// 	,calle: this.form.calle
					// 	,colonia: this.form.colonia
					// 	,cp: this.form.cp
					// 	,delegacion: this.form.municipio
					// 	,entidad_id: this.form.estado
					// 	,valor: valorPropiedad
					// 	,metodo_preferido_contacto: this.form.contacto_preferido
					// };

					// let url = process.env.VUE_APP_URL_API;
					// url += '/altasolicitud/'+process.env.VUE_APP_API_TOKEN;

					// axios.post(url, data)
					let url = process.env.VUE_APP_ORIGINACION_URL;
					url += '/application/full'

					axios.post(url, {
						email: this.form.email
						,password: this.form.email.split('@')[0]
						,nombre: this.form.nombre
						,paterno: this.form.apellido_paterno
						,materno: this.form.apellido_materno
						,ingreso_mensual: ingreso_mensual
						,telefono: this.form.telefono
						,monto_prestamo: importe_solicitado
						,plazo: this.form.plazos
						,entidad: this.form.estado
						,medioinformacion_id: 40
						,promotor_id: 2
						,descripcion_solicitud: 'Solicitud enviada vía micrositio Distrito PyME'
						,acepta_politicas_privacidad: this.form.politicas
						,importe_pre_autorizado: this.form.montoPreAprobado
						,acepta_pre_autorizado: this.form.aceptarPreAprobado
						,metodo_preferido_contacto: this.form.contacto_preferido
						,tipogarantia_id: this.form.tipoPropiedad
						,propia: 1
						,calle: this.form.calle
						,colonia: this.form.colonia
						,cp: this.form.cp
						,delegacion: this.form.municipio
						,entidad: this.form.estado
						,valor: valorPropiedad
						,api_token: process.env.VUE_APP_ORIGINACION_TOKEN
					})
					.then(res => {
						console.log('res:', res);
						this.infoSolicitud = res.data.data;
						this.$swal({
							type: 'success'
							,title: 'Se ha registrado la solicitud correctamente'
							,html: 'En breve nos comunicaremos con tigo por vía telefónica y por correo electrónico<br/>Solicitud con ID: <strong>'+res.data.data.solicitud_id+'</strong>'
							,showCancelButton: true
							,confirmButtonText: 'Subir documentos'
							,cancelButtonText: 'Aceptar'
							,reverseButtons: true
							,customClass: {
								confirmButton: 'btn btn-primary'
								,cancelButton: 'btn btn-success'
							}
							,buttonsStyling: false
						})
						.then((res) => {
							console.log('res', res);
							if (res.value) {
								//Subir documentos
								this.uploadFiles = true;
							}
						});

						this.mssg.buttons.forEach(function(item) {
							let btn = document.getElementById(item.id);

							if (btn)
								btn.disabled = false;
						});

						this.form = {
							montoPrestamo: null
							,montoPreAprobado: null
							,aceptarPreAprobado: 0
							,plazos: 0
							,nombre: null
							,ingreso: null
							,email: null
							,telefono: null
							,tipoPropiedad: 0
							,valorPropiedad: null
							,estado: null
							,municipio: null
							,colonia: 0
							,calle: null
							,cp: null
							,contacto_preferido: 'telefono'
							,politicas: false
							,createdAt: null
							,updatedAt: null
						}

						this.colonias = [];
					})
					.catch(err => {
						let error = '';

						if (err.response) {
							error = err.response.data.mensaje_cliente;
						}else if (err.request) {
							error = err.request;
						}else
							error = err.message;

						this.$swal({
							type: 'error'
							,title: 'Oops...'
							,text: error
							,toast: true
					        ,position: 'top-end'
					        ,showConfirmButton: false
					        ,timer: 5500
						});
					})
					.then(() => {
						if (monto_pre_a)
							monto_pre_a.disabled = false;

						if (monto_org_a)
							monto_org_a.disabled = false;

						if (monto_org_b)
							monto_org_b.disabled = false;

						this.mssg.buttons.forEach(function(item) {
							let btn = document.getElementById(item.id);
							if (btn)
								btn.disabled = false;
						});
					});
				})
				.catch(err => {
					this.$log.info('error firestore: ', err);
					
					this.$swal({
						type: 'error'
						,title: 'Oops...'
						,text: err.message
						,toast: true
				        ,position: 'top-end'
				        ,showConfirmButton: false
				        ,timer: 3500
					});

					this.mssg.buttons.forEach(function(item) {
						let btn = document.getElementById(item.id);
						if (btn)
							btn.disabled = false;
					});
				});
			}
			,noAceptar: function() {
				// console.log('No aceptar');
				this.form.montoPreAprobado = null;
				this.mssg = {
					img: null
					,subtitle: null
					,mssg: null
					,buttons: []
				};
			}
			,dynamicAction: function(e, action) {
				// console.log('e',e);
				// console.log('action', action);

				switch(action) {
					case 'noAceptar':
						this.noAceptar();
						break;
					case 'aceptarPre':
						this.aceptarPre(e);
						break;
					case 'guardarDatos':
						this.guardarDatos(e);
						break;
				}
			}
			,showAlert: function() {
				let montoPrestamoRaw = this.form.montoPrestamo;
				montoPrestamoRaw = montoPrestamoRaw.replace('$','');
				montoPrestamoRaw = montoPrestamoRaw.split(',');
				montoPrestamoRaw = parseFloat(montoPrestamoRaw.join(''));

				let montoPreAprobadoRaw = parseFloat(this.form.montoPreAprobado);

				// console.log('montos', montoPreAprobadoRaw, montoPrestamoRaw);
				// console.log('tipos', typeof(montoPreAprobadoRaw), typeof(montoPrestamoRaw));

				// console.log('pre menor',(montoPreAprobadoRaw < montoPrestamoRaw),(montoPreAprobadoRaw >= 200000));
				// console.log('pre mayor',(montoPreAprobadoRaw > montoPrestamoRaw),(montoPreAprobadoRaw <= 5000000));
				// console.log('mayor 5m',(montoPreAprobadoRaw >= 5000000));

				if (montoPreAprobadoRaw < montoPrestamoRaw && montoPreAprobadoRaw >= 200000) {
					this.mssg = {
						img: '/images/animat-checkmark-color.gif'
						,subtitle: '¡Felicidades!'
						,mssg: 'Tu crédito ha sido aprobado por '+this.$options.filters.currency(montoPreAprobadoRaw, '$',0)+' con la mejor tasa del mercado.'
						,buttons: [
							{
								text: 'Aceptar prestamo por '+this.$options.filters.currency(montoPreAprobadoRaw, '$',0)
								,class: 'btn btn-success'
								,action: 'aceptarPre'
								,id: 'btnAceptarMontoPre'
							}
							,{
								text: 'No me interesa'
								,class: 'btn btn-danger'
								,action: 'noAceptar'
								,id: 'btnNoAceptar'
							}
						]
					};

				}else if (montoPreAprobadoRaw > montoPrestamoRaw && montoPreAprobadoRaw <= 5000000) {
					this.mssg = {
						img: '/images/animat-checkmark-color.gif'
						,subtitle: '¡Felicidades, tienes un crédito preautorizado mayor a al monto que esperabas!'
						,mssg: 'Puedes elegir '
							   +'entre '+this.$options.filters.currency(montoPreAprobadoRaw, '$',0)+' ó '+this.form.montoPrestamo+'. Recuerda que la tasa de interés es la misma para '
							   +'las dos opciones.'
						,buttons: [
							{
								text: 'Aceptar prestamo por '+this.$options.filters.currency(montoPreAprobadoRaw, '$',0)
								,class: 'btn btn-success'
								,action: 'aceptarPre'
								,id: 'btnAceptarMontoPre'
							}
							,{
								text: 'Aceptar prestamo por '+this.form.montoPrestamo
								,class: 'btn btn-warning'
								,action: 'guardarDatos'
								,id: 'btnAceptarMonto'
							}
							,{
								text: 'No me interesa'
								,class: 'btn btn-danger'
								,action: 'noAceptar'
								,id: 'btnNoAceptar'
							}
						]
					};
				}else if (montoPreAprobadoRaw >= 5000000) {
					this.mssg = {
						img: '/images/animat-checkmark-color.gif'
						,title: '¡Felicidades!'
						,mssg: '¡Tienes un crédito preautorizado de $5,000,000 con la tasa más baja del mercado.'
						,buttons: [
							{
								text: 'Aceptar prestamo por $5,000,000'
								,class: 'btn btn-success'
								,action: 'aceptarPre'
								,id: 'btnAceptarMontoPre'
							}
							,{
								text: 'Aceptar prestamo por '+this.form.montoPrestamo
								,class: 'btn btn-success'
								,action: 'guardarDatos'
								,id: 'btnAceptarMonto'
							}
							,{
								text: 'No me interesa'
								,class: 'btn btn-danger'
								,action: 'noAceptar'
								,id: 'btnNoAceptar'
							}
						]
					};
				}else{
					this.mssg = {
						img: '/images/info.png'
						,subtitle: null
						,mssg: 'Te invitamos a comunicarte con algún promotor o agente de ventas.'
						,buttons: [
							{
								text: 'Aceptar'
								,class: 'btn btn-primary'
								,action: 'noAceptar'
								,id: 'btnNoAceptar'
							}
						]
					};
				}
			}
		}
	}
</script>

<style lang="less">
	.content {
		width: 100%;
		height: 100%;
		font-size: 14px;
		overflow: auto;

		.header {
			nav {
				background-color: #fff;
				height: 140px;
				position: relative;

				a.navbar-brand {
					position: absolute;
					top: 30px;
					left: 80px;

					img.logo_a {
						width: 70px;
					}

					img.logo_b {
						width: 120px;
						margin-left: 40px;
					}
				}

				#navMain {
					text-align: center;
					font-size: 1.15em;
					margin-left: 45vw;

					ul.navbar-nav {
						li.nav-item {
							a.nav-link {
								font-weight: bold;
							}

							a.nav-active {
								color: #00b169;
							}
						}
					}
				}
			}
		}

		.main {
			.component {
				color: #9E9E9E;
				position: relative;
				overflow: auto;

				.hooper {
					height: 468px;
					// margin-bottom: 450px;
				}

				.credito-info {
					// background-color: rgba(255,255,255,0.4);
					width: 500px;
					font-size: 1.6em;
					color: #fff;
					padding: 20px;
					position: absolute;
					top: 120px;
					left: 105px;

					.subtitle {
						font-size: 1.5em;
						font-weight: bold;
						color: rgb(202,224,80);
						// text-shadow: 5px 5px 5px #A3A3A3;
						margin-bottom: 20px;
					}
				}

				.credito {
					background-color: #fff;
					width: 35vw;
					padding: 20px;
					box-shadow: 0 0 10px grey;
					position: absolute;
					top: 60px;
					right: 130px;

					a {
						color: #00C874;
					}

					.row {
						margin-bottom: 10px;

						.title {
							text-align: center;
							font-size: 1.8em;
							color: rgb(201,224,79);

							span {
								color: rgb(0,177,105);
								font-weight: bold;
							}
						}

						.subtitle {
							text-align: center;
							color: #00C874;
							margin-top: 5px;
						}

						button {
							background-color: #5177ad;
							width: 100%;
							font-size: 2em;
							color: #fff;
							padding: 20px 0px;
							border: solid 1px #5177ad;
						}

						button:hover {
							background-color: #2873DF;
						}
					}
				}

				.info-general {
					margin-top: 70px;
					margin-bottom: 200px;

					.subtitle {
						font-size: 2.3em;
						margin-top: 20px;

						span {
							font-weight: bold;
							color: rgb(0,177,105);
						}
					}

					ul {
						list-style: none;

						li {
							font-size: 1.3em;
							position: relative;
						}

						li:before {
							color: rgb(0,177,105);
							content: "\2022";
							position: absolute;
							top: 1px;
							left: -1.2em;
						}
					}
				}

				.requisitos {
					.row {
						.video {
							font-size: 2em;

							span {
								color: #5177ad;
								font-weight: bold;
							}

							button {
								background-color: rgb(0,177,105);
								width: 250px;
								font-size: 0.7em;
								color: #fff;
								border: solid 1px rgb(0,177,105);
								margin-top: 30px;
								padding: 15px 0px;
							}
						}

						.pasos {
							ol {
								li {
									font-size: 1.7em;
									font-size: 700;
									color: #808080;
									margin: 60px 0px;
									position: relative;

									span {
										font-size: initial;
									}

									img {
										position: absolute;	
										top: -17px;
										left: -95px;
									}
								}
							}
						}
					}
				}

				.descript {
					font-size: 1.2em;

					.row {
						.col-sm-12 {
							span {
								font-size: 1.5em;
								color: rgb(81,119,173);
							}
						}

						.col-sm-12:first-child {
							span {
								margin-left: 25px
							}
						}
					}
				}

				.plazas {
					background-color: #378462;
					background-image: url('/images/deal.jpg');
					background-repeat: no-repeat;
					background-position: center;
					background-size: cover;
					font-size: 1.3em;
					color: #fff;

					.bg {
						background-color: rgba(0,177,105,.5);

						.container {
							.row {
								.subtitle {
									text-align: center;
									font-size: 2.4em;
									padding: 40px 0px;
								}

								.button {
									text-align: center;
									padding: 30px 0px;

									button {
										background-color: #fff;
										color: #385b8d;
										font-weight: bold;
										padding: 15px 100px;
										border: solid 1px #fff;
									}
								}
							}
						}
					}
				}

				.logos {
					.row {
						.col-sm-12 {
							padding: 40px;
						}

						.col-sm-12:nth-child(1) {
							img {
								width: 75px;
							}
						}

						.col-sm-12:nth-child(2) {
							img {
								width: 75px;
							}
						}

						.col-sm-12:nth-child(3) {
							img {
								width: 75px;
							}
						}

						.col-sm-12:nth-child(4) {
							img {
								width: 114px;
							}
						}

						.col-sm-12:nth-child(5) {
							img {
								width: 187px;
							}
						}

						.disc {
							text-align: center;
							font-size: 1.2em;
							color: #000;
							padding-top: 10px;
						}
					}
				}
			}

			.player_bg {
				background-color: rgba(102,102,102,0.7);
				width: 100%;
				height: 100%;
				position: fixed;
				top: 0;
				left: 0;
			}

			.player_iframe {
				background-color: #fff;
				width: 640px;
				height: 360px;
				transform: translate(-50%, -50%);
				position: fixed;
				top: 50%;
				left: 50%;

				iframe {
					width: 100%;
					height: 100%;
				}
			}

			.player_close {
				// background-color: rgba(255, 255, 255, 0.5);
				width: 45px;
				height: 45px;
				font-size: 2em;
				font-weight: bold;
				text-align: center;
				color: #fff;
				padding: 0px 10px;
				position: fixed;
				top: 20px;
				right: 30px;
				z-index: 99999;

				img {
					width: 100%;
				}
			}

			.confirm-dialog {
				background-color: #fff;
				width: 60vw;
				padding: 20px;
				transform: translate(-50%, -50%);
				position: fixed;
				top: 50%;
				left: 50%;

				.title {
					width: 20%;
				}

				.subtitle {
					font-size: 1.7em;
					font-weight: bold;
					text-align: center;
					margin-bottom: 20px;
				}

				.info {
					text-align: center;
					margin-bottom: 20px;
				}

				.buttons {
					button {
						margin-right: 10px;
					}
				}
			}
		}

		.footer {
			background-color: #CCCCCC;
			text-align: right;
			padding: 10px;
			// flex-shrink: 0;
		}
	}
	@media screen and (max-width: 991px) {
		.content {
			.main {
				.component {
					.credito-info {
						width: 450px!important;
						top: 60px!important;
						left: 30px!important;
					}

					.credito {
						right: 31px!important;
					}

					.requisitos {
						.row {
							.pasos {
								ol {
									li {
										margin-left: 30px;
										
										img {
											width: 50px !important;
											top: -3px !important;
											left: -82px !important;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	@media (max-width:767px){
		.content{
			.main {
				.component {
					.hooper {
						width: 100%!important;
						height: auto !important;

						.hooper-list {
							.hooper-track {
								.hooper-slide {
									img {
										width: 100%;
									}
								}
							}
						}
					}

					.credito-info  {
						width: 100%!important;
						color: #9E9E9E!important;
						padding-top: 3px !important;
						position: relative !important;
						top: auto !important;
						left: auto !important;

						.row {
							.subtitle {
								text-align: center;
								font-size: 1.3em;
							}
						}
					}

					.info-general {
						margin-bottom: auto !important;

						.row {
							.subtitle {
								text-align: center;
								font-size: 1.8em;
							}
						}
					}

					.credito{
						width: 90%;
						margin: auto;
						position: relative !important;
						top: auto !important;
						right: auto !important;
					}

					.requisitos {
						.row {
							.pasos {
								ol {
									li {
										margin-left: 30px;
										
										img {
											width: 50px !important;
											top: -3px !important;
											left: -82px !important;
										}
									}
								}
							}
						}
					}

					.logos {
						.row {
							.col-sm-12:last-child {
								img {
									margin-left: -47px;
								}
							}
						}
					}
				}
			}

			.player_iframe {
				width: 90vw!important;
			}
		}
	}
</style>
